import { heroImage } from '../../mock';
import { useLang } from '../../i18n/LanguageContext';

export const About = () => {
  const { t } = useLang();
  return (
    <section id="about" className="py-14 lg:py-20">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
        <div>
          <p className="text-xs tracking-[0.3em] uppercase text-gold mb-3">{t.about.label}</p>
          <h2 className="font-serif text-3xl lg:text-4xl font-bold text-white mb-5 leading-tight">
            {t.about.title}
          </h2>
          <p className="text-base text-white/70 leading-relaxed">{t.about.body}</p>
        </div>
        <div className="aspect-[4/3] overflow-hidden border border-white/10">
          <img
            src={heroImage}
            alt="Authentic Turkish barbering at The Real Turkish Barber in Bray"
            loading="lazy"
            className="w-full h-full object-cover"
          />
        </div>
      </div>
    </section>
  );
};
